import useSWR from "swr";

export const useBeneficiaries = (searchQuery) => {
    const clientsKey = searchQuery ? `/expense-beneficiary/search-beneficiary?searchParams=${searchQuery}` : `/expense-beneficiary`;
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        beneficiaries: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};